import React, { createContext, ReactNode, SetStateAction, useContext, useState } from 'react';

interface Trip {
    pointId: string;
    lat: number;
    lng: number;
    isLast?: boolean;
}

interface MapTripsContextProps {
  trip: Trip;
  setActiveTrip: React.Dispatch<SetStateAction<Trip>>;
}

const MapTripsContext = createContext<MapTripsContextProps | undefined>(undefined);

export const MapTripsProvider = ({ children }: { children: ReactNode }) => {
  const [trip, setActiveTrip] = useState<Trip>();

  return (
    <MapTripsContext.Provider value={{ trip, setActiveTrip }}>
      {children}
    </MapTripsContext.Provider>
  );
};

export const useMapTrip = () => {
  const context = useContext(MapTripsContext);
  return context;
};
